export const getExecutePurchase = (state) => state.executePurchase;

export const getEligiblePurchaseTradeDates = (state) =>
  state.executePurchase.eligibleTradeDatesAgreements?.estimatedTradeDate || {};
